import { Subscription } from 'rxjs';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ExecutionState } from '../../../assets/data/enum/executionState';
import { OperationStateService } from '../../common/_services/operation-state.service';

@Component({
  selector: 'app-x-information-bar',
  templateUrl: './x-information-bar.component.html',
  styleUrls: ['./x-information-bar.component.css'],
  standalone: false,
})
export class XInformationBarComponent implements OnInit, OnDestroy {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() sidebarOpen = true;
  localExecState: ExecutionState;
  enableMessage = true;
  private subscriptions: Subscription = new Subscription();
  executionState = ExecutionState.nostate;

  constructor(private jwtHttpService: OperationStateService) {}

  ngOnInit() {
    this.subscriptions.add(
      this.jwtHttpService.enabledMessageAlertAPI$.subscribe((check) => {
        this.enableMessage = check;
      })
    );
    // Creating subscriptions for status bar
    this.subscriptions.add(
      this.jwtHttpService.getStateOperation().subscribe((res) => {
        this.executionState = res;
        if (res != ExecutionState.nostate) {
          this.resetExecutionState();
        }
      })
    );

    this.subscriptions.add(
      this.jwtHttpService.getBarMessage().subscribe((res) => {
        this.title = res.title;
        this.subtitle = res.subtitle;
      })
    );
  }

  resetExecutionState = () => {
    setTimeout(() => {
      this.jwtHttpService.showOperationInProgress$.next(ExecutionState.nostate);
    }, 1000 * 3);
  };

  public get localExecutionState(): typeof ExecutionState {
    return ExecutionState;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
